export interface ReferralTemplatesFormProps {
  whatsAppTemplate?: string;
  emailTemplate?: string;
}

/** Placeholders allowed inside referral templates (used both for hints and validation) */
export const emailTemplatePlaceholders = ['invitedName', 'link', 'inviterName'] as const;

/** WhatsApp template does not have an invitedName field, so it's not available there */
export const whatsAppTemplatePlaceholders = ['link', 'inviterName'] as const;

export type ReferralTemplatePlaceholder = typeof emailTemplatePlaceholders[number];
